import { Injectable, Inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SVGUtilities {
    private svgTextElement: SVGTextElement;
    // private svgTextWidthCache: {[key: string]: SVGRect} = {};

    constructor(@Inject(Window) private window: Window) {
        // Initialize the svg text element for calculating text size
        const svgElement = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'svg'
        );
        const attributes: any = {
            xmlns: 'http://www.w3.org/2000/svg',
            style: 'position: absolute; left: -100000px; top: 0;'
        };
        Object.keys(attributes).forEach((key) =>
            svgElement.setAttribute(key, attributes[key])
        );

        this.svgTextElement = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'text'
        );

        svgElement.appendChild(this.svgTextElement);

        document.body.appendChild(svgElement);
    }

    outputTranslate(x: number, y: number) {
        return `translate(${x},${y})`;
    }

    /**
     * Returns the width of a given string when inside of an svg text element
     *
     * @param text
     * @param fontSize
     */
    computeSvgTextWidth(
        text: string,
        fontSize: number,
        fontFamily?: string
    ): SVGRect {
        this.svgTextElement.textContent = text;
        this.svgTextElement.setAttribute('font-size', fontSize.toString());
        if (fontFamily) {
            this.svgTextElement.setAttribute('font-family', fontFamily);
        }
        return this.svgTextElement.getBBox();
    }

    primePump() {
        this.svgTextElement.textContent = 'hi there';
        this.svgTextElement.setAttribute('class', 'testClass');
    }

    hackabillly(fontFamily?: string) {
        this.svgTextElement.textContent = 'hi there';
        this.svgTextElement.setAttribute('font-family', fontFamily);
    }

    getPaddingBottom(width: number, height: number): string {
        const padding = Math.ceil((height / width) * 100) + 1;
        return padding + '%';
    }

    /* This is needed because of the way PHANTOM and other old browsers use base
     * when lookind at urls in SVG. SO you need to add the whole path to tell it
     * to look in the current page.
     */
    getGradientUrl(id: string) {
        const baseUrl = this.window.location.href.replace(
            window.location.hash,
            ''
        );
        return `url(${baseUrl}#${id})`;
    }
}
